import { Select } from 'components/Toolkit/Inputs/Select';

export type ListSingleSelectOption = {
  value: string;
  label: string;
};

export interface IListSingleSelectProps {
  name: string;
  label: string;
  value: string;
  options: ListSingleSelectOption[];
  onChange: (value: string) => void;
  className?: string;
}

function ListSingleSelect({
  options,
  label,
  name,
  className,
  onChange,
  value,
}: IListSingleSelectProps) {
  return (
    <>
      {options && (
        <Select
          label={label}
          className={className}
          onChange={onChange}
          name={name}
          value={value}
          options={options}
        />
      )}
    </>
  );
}

export { ListSingleSelect };
